/* eslint-disable no-undefined */
import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import Logo from 'assets/logo-white.png';
import {isTablet, isIPad13, isIOS, isMacOs, getUA} from 'react-device-detect';
import {begin} from 'utils/beforeunload';
import strings from 'utils/strings';
import Introduksjon from 'components/Introduksjon';
import Orddiktat from 'components/Orddiktat';
import Ordkjedetesten from 'components/Ordkjedetesten';
import Tulleordtesten from 'components/Tulleordtesten';
import SprakForstaelse from 'components/SprakForstaelse';
import Skrivehastighet from 'components/Skrivehastighet';
import Leseproven from 'components/Leseproven';
import Ordforstaelse from 'components/Ordforstaelse';
import Ferdig from 'components/Ferdig';
import ProgressBar from 'components/ProgressBar';
import getTestInfo from 'api/getTestInfo';
import getUserInfo from 'api/getUserInfo';
import upsertTestInfo from 'api/upsertTestInfo';
import {setTestCandidateGrade} from 'actions/index';
import primeAudioPlayback from 'utils/primeAudioPlayback';

const testSteps = [
	Introduksjon,
	Tulleordtesten,
	Ordkjedetesten,
	Skrivehastighet,
	Ordforstaelse,
	Leseproven,
	Orddiktat,
	Ferdig,
];
const testStepsWithoutReading = [
	Introduksjon,
	Tulleordtesten,
	Ordkjedetesten,
	Skrivehastighet,
	Ordforstaelse,
	Orddiktat,
	Ferdig,
];

const testStepsNorming = [
	Introduksjon,
	Tulleordtesten,
	SprakForstaelse,
	Ordkjedetesten,
	Skrivehastighet,
	Ordforstaelse,
	Leseproven,
	Orddiktat,
	Ferdig,
];

const hasStoredGender = (testUserInfo) => {
	const gender = testUserInfo && testUserInfo.gender;
	return gender === 'f' || gender === 'm';
};

const hasStoredIsForeign = (testUserInfo) => {
	const isForeign = testUserInfo && testUserInfo.isForeign;
	return isForeign === 0 || isForeign === 1 || isForeign === 2;
};

const hasStoredBirthDate = (testUserInfo) =>
	Boolean(testUserInfo && testUserInfo.birthDate);

const getNormingProgressLabel = (Step) => {
	switch (Step) {
		case Tulleordtesten:
			return 'Byttelydtesten';
		case SprakForstaelse:
			return strings.spraktesten || 'Setningsforståelse';
		case Ordkjedetesten:
			return strings.ordkjedetesten;
		case Skrivehastighet:
			return strings.skrivehastighet;
		case Ordforstaelse:
			return strings.ordforstaelse;
		case Leseproven:
			return strings.leseproven;
		case Orddiktat:
			return strings.orddiktat;
		default:
			return '';
	}
};

class ScreeningTest extends React.Component {
	
	constructor() {
		super();

		this.state = {
			isLoggedIn: false,
			isDldTest:false,
			needLanguageSetting: false,
			testUserInfo: null,
			isPortrait: true,
		};
		this.handleResize = this.handleResize.bind(this);

		this.renderRemainingTests = [];
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('orientationchange', this.handleResize);
		if (
			window.visualViewport &&
			typeof window.visualViewport.addEventListener === 'function'
		) {
			window.visualViewport.addEventListener('resize', this.handleResize);
		}
		this.initializeTestFlow();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('orientationchange', this.handleResize);
		if (
			window.visualViewport &&
			typeof window.visualViewport.removeEventListener === 'function'
		) {
			window.visualViewport.removeEventListener('resize', this.handleResize);
		}
	}

	// eslint-disable-next-line complexity
	initializeTestFlow = async () => {
  try {
    const testInfo = await getTestInfo();
    if (!testInfo) {
      console.warn('No test info received');
      return;
    }
    var exclusiveTests = (testInfo && testInfo.exclusiveTests) ? testInfo.exclusiveTests : {};
    var excludeReading = Boolean(testInfo && testInfo.excludeReading);
    var isDldTest = Boolean(testInfo && testInfo.isDldTest);
    var testUserInfo = testInfo.info || null;

    var rawGrade = testInfo ? testInfo.grade : undefined;
    var grade = (rawGrade !== null && rawGrade !== undefined) ? Number(rawGrade) : NaN;
    if (!Number.isNaN(grade)) {
      this.props.onSetTestCandidateGrade(grade);
    }

    var testToContinue = Object.values(exclusiveTests);
	if (testToContinue && testToContinue.length) {
      var continueCodes = new Set(
        testToContinue
          .map(function (v) { return Number(v); })
          .filter(function (n) { return Number.isFinite(n); })
      );

      var ordered = [];
      ordered.push({ code: 3, Comp: Tulleordtesten });
      if (isDldTest) { ordered.push({ code: 7, Comp: SprakForstaelse }); }
      ordered.push({ code: 2, Comp: Ordkjedetesten });
      ordered.push({ code: 4, Comp: Skrivehastighet });
      ordered.push({ code: 6, Comp: Ordforstaelse });
      if (!excludeReading) { ordered.push({ code: 5, Comp: Leseproven }); }
      ordered.push({ code: 1, Comp: Orddiktat });

	  this.renderRemainingTests = ordered
		.filter(function (step) { return continueCodes.has(step.code); })
		.map(function (step) { return step.Comp; });

		if (this.renderRemainingTests.length) {
			const needsContinuationUserInfo =
				!hasStoredGender(testUserInfo) ||
				!hasStoredIsForeign(testUserInfo) ||
				!hasStoredBirthDate(testUserInfo);

			if (needsContinuationUserInfo) {
				this.renderRemainingTests.unshift(Introduksjon);
			}

			this.renderRemainingTests.push(Ferdig);
			this.setState({ needLanguageSetting: true, isDldTest: isDldTest });
		}
    }

	if (isDldTest && !this.state.deviceInfoSaved) {
				try {
					var ua = '';
					if (typeof getUA === 'string' && getUA) {
						ua = getUA;
					} else if (
						typeof navigator !== 'undefined' &&
						navigator.userAgent
					) {
						ua = navigator.userAgent;
					}

					var hasNavigator = typeof navigator !== 'undefined';
					var maxTouchPoints =
						hasNavigator &&
						typeof navigator.maxTouchPoints === 'number'
							? navigator.maxTouchPoints
							: 0;

					var isLikelyIPad =
						(isMacOs && maxTouchPoints > 1) ||
						/iPad/i.test(ua) ||
						Boolean(isIPad13) ||
						(isIOS && isTablet);

					var isLikelyTablet =
						Boolean(isTablet) ||
						/iPad/i.test(ua) ||
						(isMacOs && maxTouchPoints > 1);
					await upsertTestInfo({
						testDevice: isLikelyIPad ? 'ipad' : 'non-ipad',
						isTablet: Boolean(isLikelyTablet),
					});
					this.setState({deviceInfoSaved: true});
				} catch (e) {
					console.warn('Device info upsert failed:', e);
				}
			}

    var response = await getUserInfo();
    if (response && response.ok) {
      this.setState({
        isDldTest: isDldTest,
        isLoggedIn: true,
        excludeReading: excludeReading,
        testUserInfo: testUserInfo,
      });
      begin();
    } else {
      window.location.href = '/';
    }
  } catch (err) {
    console.error('Error initializing test flow:', err);
  }
};

	handleResize = () => {
		const viewport = window.visualViewport || window;
		const isLandscape =
			typeof window.matchMedia === 'function'
				? window.matchMedia('(orientation: landscape)').matches
				: viewport.width > viewport.height;
		const isPortrait = !isLandscape;

		if (this.state.isPortrait !== isPortrait) {
			this.setState({isPortrait});
		}
	};

	onSelectLanguage(lang) {
		primeAudioPlayback();
		strings.setLanguage(lang);
		this.setState({
			needLanguageSetting: false,
		});
	}
	render() {
		const {isLoggedIn, isPortrait} = this.state;

		if (!isLoggedIn) {
			return null;
		}

		const {currentStepIndex} = this.props;

		let activeTestSteps = testSteps;
		if (this.renderRemainingTests.length) {
			activeTestSteps = this.renderRemainingTests;
		}
		else if(this.state.isDldTest) {
			activeTestSteps = testStepsNorming;
		}
		else if(this.state.excludeReading) {
			activeTestSteps = testStepsWithoutReading;
		}

		const CurrentStep = activeTestSteps[currentStepIndex];
		const normingProgressSteps = activeTestSteps.filter(
			(Step) => Step !== Introduksjon && Step !== Ferdig
		);
		const currentProgressStepIndex =
			normingProgressSteps.indexOf(CurrentStep);
		const shouldShowProgressBar =
			this.state.isDldTest &&
			!this.state.needLanguageSetting &&
			currentProgressStepIndex !== -1;

		const isLandscape = !isPortrait;
		return (
			<div
				className={`screening-test-app${
					isLandscape ? ' screening-test-app--landscape' : ''
				}`}
			>
				<header className="lit-header">
					<h1 className="lit-logo">
						<img
							className="lit-logo__img"
							src={Logo}
							alt="literate logo"
						/>
					</h1>
					{shouldShowProgressBar && (
						<div className="lit-header__progress">
							<ProgressBar
								completedCount={currentProgressStepIndex + 1}
								totalCount={normingProgressSteps.length}
								currentLabel={getNormingProgressLabel(
									CurrentStep
								)}
							/>
						</div>
					)}
				</header>
				{Boolean(this.renderRemainingTests.length) &&
					this.state.needLanguageSetting && (
						<div className="lit-wrapper--article text-center">
							<div className="lit-test-intro">
								<h1>{`Velg/vel språk`}</h1>

								<button
									className="lit-test-intro-language-button"
									tabIndex="1"
									onClick={() => this.onSelectLanguage('no')}
								>
									{`Norsk Bokmål`}
								</button>
								<button
									className="lit-test-intro-language-button"
									tabIndex="2"
									onClick={() => this.onSelectLanguage('nn')}
								>
									{`Norsk Nynorsk`}
								</button>
							</div>
						</div>
					)}
				{!this.state.needLanguageSetting && (
					<div className="screening-test-content lit-wrapper--article text-center">
						<CurrentStep
							isDldTest={this.state.isDldTest}
							testUserInfo={this.state.testUserInfo}
							isContinuation={
								Boolean(
									this.renderRemainingTests.length &&
									CurrentStep === Introduksjon
								)
							}
						/>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentStepIndex} = state;

	return {
		currentStepIndex,
	};
};
const mapDispatchToProps = {
	onSetTestCandidateGrade: setTestCandidateGrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningTest);
